export default __webpack_public_path__ + "static/media/HS-LogoOnly.f629f2f9.png";